import { Component, OnInit, Injector, Input } from '@angular/core';
import { DocumentService } from '../../../../../ve.service';
import { ReportsService } from '../reports.service';
import { WorkOrderFileUploadComponent } from '../../../../work-order-file-upload/work-order-file-upload.component';

@Component({
  selector: 'ga-wo-report-files',
  templateUrl: './ga-wo-report-files.component.html',
  styleUrls: ['./ga-wo-report-files.component.scss']
})
export class GaWoReportFilesComponent extends WorkOrderFileUploadComponent implements OnInit {
  @Input() fileType: string;
  reportsService: ReportsService;
  documentService: DocumentService;

  constructor(injector: Injector) {
    super(injector);
    this.reportsService = injector.get(ReportsService);
    this.documentService = injector.get(DocumentService);
  }

  ngOnInit() {
    this.fileUploadService.uploadSaveUrl = this.documentService.getUploadUrl('VE_GA', true);
    this.fileUploadService.fileType = this.fileType;
    this.fileUploadService.workOrderId = this.reportsService.editForm.get('Id').value;
    Promise.all([
      // this.fileUploadService.getDocumentTypes(),
      // this.fileUploadService.getDocuments()
      this.fileUploadService.getFiles()
    ]);
  }
}
